// extracted by mini-css-extract-plugin
export default {"wrapper":"Register_wrapper__mkz0i","stuleSelektKod":"Register_stuleSelektKod__R6Tn0","button":"Register_button__q47OS","input":"Register_input__bVwCU"};